var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimer(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.067 1.65h-.75v2.887a.75.75 0 001.5 0v-1.33a4.92 4.92 0 014.166 4.86 4.919 4.919 0 01-4.916 4.916A4.919 4.919 0 013.15 8.067a.75.75 0 10-1.5 0 6.419 6.419 0 006.417 6.416 6.419 6.419 0 006.416-6.416A6.419 6.419 0 008.067 1.65zM4.869 4.481a.75.75 0 00-.937 1.171L7.264 8.32a.75.75 0 00.937-1.171L4.869 4.48z",
    fill: "#111927"
  })));
}
export default SvgTimer;